import {Component, Input} from '@angular/core';
import {CommonModule} from '@angular/common';

@Component({
    selector: 'app-chick-info',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './chick-info.component.html',
    styleUrl: './chick-info.component.scss'
})
export class ChickInfoComponent {
    @Input() placement: any | null = null;
    @Input() breedName: string | null = null;
    @Input() targetWeight: number | string | null = null;
    @Input() qty: number | string | null = null;
    @Input() parentStockAge: number | string | null = null;
    @Input() disInfectionProgram: string | null = null;
    @Input() vaccineName: string | null = null;
    @Input() litterType: string | null = null;
}
